module.exports = __webpack_public_path__ + "img/202405_01_sp.071f1004.jpg";